import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const LogoutComponent = () => {
    const { logout } = useAuth0();
    
    useEffect(() => {
      logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      });
    }, [logout]);
    
    return <div>Logging out...</div>;
};